export type RecentPurchase = {
  name: string
  city: string
  minutesAgo: number
}

export const recentPurchases: RecentPurchase[] = [
  { name: 'Giulia R.', city: 'Milano', minutesAgo: 3 },
  { name: 'Marco T.', city: 'Bologna', minutesAgo: 7 },
  { name: 'Francesca P.', city: 'Napoli', minutesAgo: 11 },
  { name: 'Elisa M.', city: 'Torino', minutesAgo: 16 },
  { name: 'Davide S.', city: 'Firenze', minutesAgo: 22 },
  { name: 'Chiara B.', city: 'Palermo', minutesAgo: 27 },
  { name: 'Silvia G.', city: 'Verona', minutesAgo: 34 },
  { name: 'Antonio L.', city: 'Bari', minutesAgo: 41 },
]
